import React from 'react';

/* ═══════════════════════════════════════════════════════════════
   DASHBOARD ICONS
   Single-color, stroke-based line icons — replaces all emoji use
   in the dashboard. Swap any path here to re-skin every instance
   of that icon across the dashboard at once.
═══════════════════════════════════════════════════════════════ */
const base = {
  width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round',
};

export const Icon = ({ name, size = 18, ...rest }) => {
  const props = { ...base, width: size, height: size, ...rest };
  switch (name) {
    case 'revenue': // rupee in circle
      return (<svg {...props}><circle cx="12" cy="12" r="9" /><path d="M9 8h6M9 8c0 2.5 2 3.5 4 3.5H9m0 0 5 4.5M9 11.5h6" /></svg>);
    case 'orders': // shopping bag
      return (<svg {...props}><path d="M6 8h12l-1 12H7L6 8Z" /><path d="M9 8a3 3 0 0 1 6 0" /></svg>);
    case 'aov': // receipt
      return (<svg {...props}><path d="M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5V3Z" /><path d="M9 8h6M9 12h6M9 16h3" /></svg>);
    case 'profit': // trending up
      return (<svg {...props}><path d="M4 16 10 10l4 4 6-7" /><path d="M15 7h5v5" /></svg>);
    case 'active': // clock (live orders)
      return (<svg {...props}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3.5 2" /></svg>);
    case 'outstanding': // alert circle
      return (<svg {...props}><circle cx="12" cy="12" r="9" /><path d="M12 8v5" /><circle cx="12" cy="16" r="0.6" fill="currentColor" stroke="none" /></svg>);
    case 'gst': // tax / percent badge
      return (<svg {...props}><rect x="4" y="4" width="16" height="16" rx="4" /><path d="M9 15 15 9" /><circle cx="9.5" cy="9.5" r="0.6" fill="currentColor" stroke="none" /><circle cx="14.5" cy="14.5" r="0.6" fill="currentColor" stroke="none" /></svg>);
    case 'up':
      return (<svg {...props}><path d="M6 15 12 9l6 6" /></svg>);
    case 'down':
      return (<svg {...props}><path d="M6 9 12 15l6-6" /></svg>);
    case 'refresh':
      return (<svg {...props}><path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3" /><path d="M18 4v4h-4M6 20v-4h4" /></svg>);
    case 'calendar':
      return (<svg {...props}><rect x="4" y="5" width="16" height="15" rx="2" /><path d="M4 10h16M8 3v4M16 3v4" /></svg>);
    case 'items': // grid / plate
      return (<svg {...props}><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="3" /></svg>);
    case 'rank': // number badge
      return (<svg {...props}><rect x="4" y="4" width="16" height="16" rx="4" /></svg>);
    case 'new': // sparkle
      return (<svg {...props}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" /></svg>);
    case 'empty':
      return (<svg {...props}><rect x="4" y="4" width="16" height="16" rx="3" /><path d="M9 9h.01M15 9h.01M9 15c1-1 5-1 6 0" /></svg>);
    default:
      return null;
  }
};

export default Icon;